import React from 'react';
import { X, Calendar, Users, Building, User } from 'lucide-react';

const ProjectModal = ({ isOpen, onClose, title, projects, metricType }) => {
  if (!isOpen) return null;

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    // Parse the date as local time to avoid timezone offset issues
    const dateParts = dateString.split('-');
    const date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
    return date.toLocaleDateString();
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Completed':
        return 'text-green-600';
      case 'Go-Live Pushed':
        return 'text-orange-600';
      case 'In progress':
        return 'text-blue-600';
      case 'Staging':
        return 'text-gray-600';
      default:
        return 'text-gray-600';
    }
  };

  const getHealthColor = (health) => {
    if (health?.includes('Green')) return 'text-green-600';
    if (health?.includes('Yellow')) return 'text-yellow-600';
    if (health?.includes('Red')) return 'text-red-600';
    return 'text-gray-600';
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        
        <div className="modal-body">
          {projects.length === 0 ? (
            <div className="no-projects">
              <p>No projects found for this metric.</p>
            </div>
          ) : (
            <div className="projects-list">
              {projects.map((project) => (
                                 <div key={project.projectId} className="project-card">
                   <div className="project-header">
                     <h3 className="project-name">
                       <a 
                         href={`https://projects.onesourcevirtual.com/projects/${project.projectId}`}
                         target="_blank"
                         rel="noopener noreferrer"
                         className="project-link"
                         title="Open in RocketLane"
                       >
                         {project.projectName}
                       </a>
                     </h3>
                     <span className={`project-status ${getStatusColor(project.status?.label)}`}>
                       {project.status?.label || 'Unknown'}
                     </span>
                   </div>
                  
                  <div className="project-details">
                    <div className="detail-row">
                      <Calendar size={16} />
                      <span>Go Live: {formatDate(project.fields?.find(f => f.fieldLabel === 'Services Go Live Date')?.fieldValue)}</span>
                    </div>
                    
                    <div className="detail-row">
                      <Building size={16} />
                      <span>Customer: {project.customer?.companyName || 'N/A'}</span>
                    </div>
                    
                                         <div className="detail-row">
                       <Users size={16} />
                       <span>Team: {project.teamMembers?.members?.length || 0} members</span>
                     </div>
                     
                     <div className="detail-row">
                       <User size={16} />
                       <span>Owner: {project.owner?.firstName} {project.owner?.lastName}</span>
                     </div>
                    
                    {metricType === 'health' && (
                      <div className="detail-row">
                        <span className={`health-status ${getHealthColor(project.fields?.find(f => f.fieldLabel === 'Project Health')?.fieldValueLabel)}`}>
                          Health: {project.fields?.find(f => f.fieldLabel === 'Project Health')?.fieldValueLabel || 'Not Set'}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;
